import Service from '../lib/service'
import streamService from './stream'
import request from '../lib/request'

export class StreamChatService extends Service {
  constructor() {
    super()
    this.chatsPromise = null
    this.unreadHandler = null
    this.mineChannels = []
  }

  async setUser(user) {
    if (user?.uuid) {
      await this.initStream()
    }
  }

  async initStream() {
    const channels = await this.getUserChannels()
    this.mineChannels = channels

    if (this.mineChannels.length === 0) {
      this.setUnreadCount(0)
      return
    }

    await streamService.connect()

    await this.calculateMineUnreadCount()

    if (!this.unreadHandler) {
      this.unreadHandler = async () => {
        this.chatsPromise = null
        await this.calculateMineUnreadCount()
      }

      streamService.on('unread.total', this.unreadHandler)
    }
  }

  async calculateMineUnreadCount() {
    try {
      // Get all Stream channels
      const streamChannels = await streamService.getUserStreamChannels()

      // Create a Set of active channel keys for quick lookup
      const myChannelKeys = new Set(
        this.mineChannels.map(ch => ch.stream_channel_key).filter(Boolean)
      )

      // Filter to only my channels and sum unread counts
      const total = streamChannels.reduce((sum, streamChannel) => {
        const channelKey = streamChannel.id

        if (myChannelKeys.has(channelKey)) {
          return sum + (streamChannel.state?.unreadCount || 0)
        }

        return sum
      }, 0)

      this.setUnreadCount(total)
    } catch (error) {
      console.error('Error calculating mine unread count:', error)
      this.setUnreadCount(0)
    }
  }

  setUnreadCount(unreadCount) {
    this.emit('unreadCount', unreadCount)
  }

  async getChats(force = false) {
    if (!force && this.chatsPromise) {
      return this.chatsPromise
    }

    this.chatsPromise = (async () => {
      const channels = this.mineChannels

      if (channels.length === 0) {
        this.emit('teams', [])
        return []
      }

      const streamChannels = await streamService.getUserStreamChannels();
      const streamMap = new Map(streamChannels.map(c => [c.id, c]))

      const results = channels.map(channel => {
        const streamChannel = streamMap.get(channel.stream_channel_key) || {}
        const unreadCount = streamChannel.state?.unreadCount || 0

        return {
          id: channel.originator_id || channel.id,
          name: channel.display_name,
          unreadCount,
          originator_system: channel.originator_system,
          originator_type: channel.originator_type,
          originator_id: channel.originator_id,
          avatar: {
            imgUrl: channel.image_url || streamChannel.data?.image,
            identity: channel.display_name,
            type: channel.originator_type,
            sport: channel.sport,
            color: channel.primary_color,
            size: 300,
          },
        }
      })

      // Sort by unread count descending
      results.sort((a, b) => (b.unreadCount || 0) - (a.unreadCount || 0))

      this.emit('teams', results)
      return results
    })()

    return this.chatsPromise
  }

  async getUserChannels() {
    const channelChatUsers = await request.get('v3/chat/channels_chat_users/mine')
    return channelChatUsers.map(ccu => ccu.channel)
  }
}

const streamChatService = new StreamChatService()
export default streamChatService
